import { types } from 'mobx-state-tree'

export const CertificationStats = types.model('CertificationStats').props({
  level: types.maybeNull(types.string),
  order: types.maybeNull(types.number),
  percent: types.number,
  user_count: types.number,
})
